export interface DataId {
  id: string;
  name: string;
}
export const DISPLAY_COLUMN: string[] = [
  'techVehicleNo',
  'registrationNo',
  'vehicleType',
];

export const COLUMN_LIST: DataId[] = [
  {
    id: 'techVehicleNo',
    name: 'ID',
  },
  {
    id: 'registrationNo',
    name: 'Vehicle Number',
  },
  {
    id: 'vehicleType',
    name: 'Vehicle Type ID',
  },
];
